import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useAffiliateForm } from './Hooks/AddAffiliatePopup.hooks';
import { AffiliateFormContent, PopupFooter } from './Subcomponents/AddAffiliatePopup.subcomponents';

// ============================================================
// MAIN COMPONENT
// ============================================================

const AddAffiliatePopup = props => {
    const { showAddAffiliatePopup, setShowAddAffiliatePopup, onAddAffiliate } = props;
    const { formData, errors, isLoading, onFieldChange, handleAddAffiliate, resetForm } = useAffiliateForm(onAddAffiliate);

    const handleClose = () => {
        resetForm();
        setShowAddAffiliatePopup(false);
    };

    return (
        <Modal
            {...props}
            show={showAddAffiliatePopup}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={handleClose}
            className="filterShippingListModal addAffiliate modalDeleteWrapper generateKey"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Add Company/Seller</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AffiliateFormContent
                    formData={formData}
                    errors={errors}
                    onFieldChange={onFieldChange}
                />
                <PopupFooter onSubmit={handleAddAffiliate} isLoading={isLoading} />
            </Modal.Body>
        </Modal>
    );
};

AddAffiliatePopup.propTypes = {
    showAddAffiliatePopup: PropTypes.bool,
    setShowAddAffiliatePopup: PropTypes.func,
    onAddAffiliate: PropTypes.func,
};

export default AddAffiliatePopup;
